import { makeUseDocumentPath, makeUseSelector } from '@common/store-tools';
import { CheckInReduxState } from './reduxStore';
import type { CheckinCollections } from '@contracts/checkin';
import { RoomCollections } from '@contracts/room/collections';

export const useDocumentPath = makeUseDocumentPath<
	CheckinCollections & RoomCollections
>();
export const useSelector = makeUseSelector<CheckInReduxState>();
